import { injectable } from 'inversify'
import { IUserProfile, IUserProfileFactory, UserProfileFactoryInput } from '@/types'
import UserProfile from '@/entities/UserProfile'

@injectable()
export default class UserProfileFactory implements IUserProfileFactory {
  public create(input: UserProfileFactoryInput): IUserProfile {
    return new UserProfile(input.base)
  }
}
